/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MedicationScheduleAliases {
  CONTEXTUAL_BAR = 'contextual-bar',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  MEDICATION_SCHEDULE_CONTENT_AUTOCOMPLETE = 'medication-schedule-content-autocomplete',
  MEDICATION_SCHEDULE_CONTENT_AUTOCOMPLETE_FETCH = 'medication-schedule-content-autocomplete-fetch',
  MEDICATION_SCHEDULE_CONTENT_AUTOCOMPLETE_FIELD = 'medication-schedule-content-autocomplete-field',
  MEDICATION_SCHEDULE_CONTENT_AUTOCOMPLETE_MAPPER = 'medication-schedule-content-autocomplete-mapper',
  MEDICATION_SCHEDULE_CONTENT_AUTOCOMPLETE_TEXT = 'medication-schedule-content-autocomplete-text',
  MEDICATION_SCHEDULE_CONTENT_FIELD = 'medication-schedule-content-field',
  MEDICATION_SCHEDULE_CONTENT_FORM = 'medication-schedule-content-form',
  MEDICATION_SCHEDULE_CONTENT_FORM_FIELD = 'medication-schedule-content-form-field',
  MEDICATION_SCHEDULE_CONTENT_FORM_PANEL = 'medication-schedule-content-form-panel',
  MEDICATION_SCHEDULE_CONTENT_PANEL = 'medication-schedule-content-panel',
  MEDICATION_SCHEDULE_CONTENT_TEXT = 'medication-schedule-content-text',
  MEDICATION_SCHEDULE_CONTENT_TEXT_AREA = 'medication-schedule-content-text-area',
  MEDICATION_SCHEDULE_CONTENT_TEXT_AREA_FIELD = 'medication-schedule-content-text-area-field',
  MEDICATION_SCHEDULE_INPUT_DATE_TIME_FIELD = 'medication-schedule-input-date-time-field',
  MEDICATION_SCHEDULE_LAYOUT = 'medication-schedule-layout',
  MEDICATION_SCHEDULE_TOAST_NOTIFICATION = 'medication-schedule-toast-notification',
  MEDICATION_SCHEDULE_TOAST_NOTIFICATION_PANEL = 'medication-schedule-toast-notification-panel',
  TOAST_NOTIFICATION_ALERT = 'toast-notification-alert',
  TOAST_NOTIFICATION_PANEL_ALERT = 'toast-notification-panel-alert',
}
export { MedicationScheduleAliases };
